/* eslint-disable import/prefer-default-export */

/* eslint-disable react/no-danger */
import classnames from 'classnames';
import React from 'react';

import styles from './DraggableItem.scss';

interface DropPlaceholderProps {
  show?: boolean;
  height?: number;
}

const DropPlaceholder = ({ show = null, height = null }: DropPlaceholderProps) => (
  <div
    className={show ? styles.drop_target : ''}
    style={{ height: show ? `${height}px` : '0', overflow: 'hidden' }}
  />
);

interface DraggableItemProps {
  text?: string;
  orderNumber?: number;
  isPreview?: boolean;
  setRef?: (...args: unknown[]) => unknown;
  width?: number;
  placeholderHeight?: number;
  isDragging?: boolean;
  showDropPlaceholderAbove?: boolean;
  showDropPlaceholderBellow?: boolean;
  isValidDropTarget?: boolean;
}

export const DraggableItem = ({
  isDragging = null,
  isPreview = false,
  isValidDropTarget = false,
  orderNumber = null,
  placeholderHeight = null,
  setRef = null,
  showDropPlaceholderAbove = null,
  showDropPlaceholderBellow = null,
  text = '',
  width = null
}: DraggableItemProps) => {
  const isOrderNumber = Number.isInteger(orderNumber);
  const containerStyles = classnames(styles.container, { [styles.preview]: isPreview });
  const orderNumberClasses = classnames(styles.number_container, {
    [styles.is_dragging]: isDragging,
    [styles.not_valid_target]: !isValidDropTarget
  });

  const callSetRef = (ref) => {
    if (ref === null) {
      return;
    }
    if (setRef) {
      setRef(ref);
    }
  };

  return (
    <div>
      <DropPlaceholder show={showDropPlaceholderAbove} height={placeholderHeight} />
      <div
        role="button" // added Role button to recognize the draggable item as an actionable in Rotor.
        tabIndex="-1" // set tabindex to -1 to remove container from logical focus order on JAWS.
        className={containerStyles}
        ref={callSetRef}
        style={width ? { width: `${width}px` } : {}}>
        <div className={styles.icon_container}>
          <svg width="7" height="14">
            <g fill="#A8A8A8" fillRule="nonzero">
              <circle cx="1" cy="1" r="1" />
              <circle cx="1" cy="7" r="1" />
              <circle cx="1" cy="13" r="1" />
              <circle cx="6" cy="1" r="1" />
              <circle cx="6" cy="7" r="1" />
              <circle cx="6" cy="13" r="1" />
            </g>
          </svg>
        </div>

        {isOrderNumber && (
          <div className={orderNumberClasses} aria-hidden>
            {orderNumber + 1}
          </div>
        )}
        <div className={styles.text} dangerouslySetInnerHTML={{ __html: text }} />
      </div>
      <DropPlaceholder show={showDropPlaceholderBellow} height={placeholderHeight} />
    </div>
  );
};
